export const ROUTES = {
  LANDING: '/',
  AUTH: '/auth',
  ONBOARDING: '/onboarding',
  /** Legacy path. Redirects to OVERVIEW; kept so old links and bookmarks work. */
  DASHBOARD: '/dashboard',
  OVERVIEW: '/overview',
  ATTENTION: '/attention',
  /** Next week's posts, proposed (Task 2.3). */
  PLAN: '/plan',
  COMPOSER: '/composer',
  COMPOSER_EDIT: '/composer/:id',
  INBOX: '/inbox',
  INBOX_SETTINGS: '/inbox/settings',
  BRAND: '/brand',
  BRAND_SETUP: '/brand/setup',
  ANALYTICS: '/analytics',
  TEMPLATES: '/templates',
  MEDIA: '/media',
  SETTINGS: '/settings',
  POSTS: '/posts',
  APPROVALS: '/approvals',
  /** Notification history: everything the bell showed, read or not (M10). */
  NOTIFICATIONS: '/notifications',
  FEEDS: '/feeds',
  CALENDAR: '/calendar',
  CHANNELS: '/channels',
  TEAM: '/team',
  ADMIN: '/admin',
  DOCS: '/docs',
  RESET_PASSWORD: '/auth/reset-password',
  /** An email's one-click unsubscribe link: /email/unsubscribe?t=… (no sign-in, AL-32). */
  EMAIL_UNSUBSCRIBE: '/email/unsubscribe',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  /** Public status of a Meta data deletion request: /data-deletion?code=… (no sign-in). */
  DATA_DELETION: '/data-deletion',
  /** Public approval page for a client without an account: /approve/:token (Task 5.1). */
  APPROVE: '/approve/:token',
  /** An invitation link (M-01): /invite/:token, public; /invite lists my pending invitations. */
  INVITE: '/invite/:token',
  INVITES: '/invite',
} as const;

/** The id of the credits section on Billing and plan, for a link that lands on it. */
export const CREDITS_SECTION_ID = 'credits';

/** Billing and plan, scrolled to the credit wallet and its packs. */
export const CREDITS_URL = `${ROUTES.SETTINGS}?tab=subscription#${CREDITS_SECTION_ID}`;

/** Where a signed-in user lands: the overview is the home screen. */
export const HOME_ROUTE = ROUTES.OVERVIEW;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
